import { ViewerCamera } from '../../../babylon/camera/ViewerCamera.js';
import { log_instance } from '../utils/LogInstance.js';
export const CAMERA_DESCRIPTION = {
    type: ViewerCamera,
    name: 'viewer-camera-default-description',
    is_enabled: true,
    initiate_tabs: [
        {
            tag: 'Cameras',
            setup: (tab, camera) => {
                const container = tab.get_container('🎥 ' + camera.name, { is_collapsed: true });
                container.watch(camera, 'position', { is_readonly: true, is_collapsed: true });
                container.custom.watch('checkbox', {
                    name: 'Is Active',
                    get: () => camera.viewer.get_active_camera() === camera,
                    set: () => {
                        if (camera.viewer.get_active_camera() === camera) {
                            camera.viewer.pop_camera();
                        }
                        else {
                            camera.viewer.push_camera(camera);
                        }
                    }
                });
                container.button('Dispose', { on_click: () => camera.dispose() });
                container.button('Log', { on_click: () => log_instance(camera) });
            }
        }
    ]
};
//# sourceMappingURL=ViewerCameraDescription.js.map